/* nesw-offer-bar.js — paints every [data-nesw-offer-bar] on the page from the
   cart. Counts the quantity of lines whose product counts (data-eligible handles
   when set, else everything not in data-excluded), reads the tiers off the
   element, and writes the fill width, the hit markers, the state and the line.
   Repaints on cart:change / cart:refresh (the theme's drawer announces both with
   the cart as detail), on pageshow, and once at load from /cart.js. */
(function () {
  if (window.__neswOfferBar) return;
  window.__neswOfferBar = true;
  function parseTiers(s) {
    return String(s || '').split(',').map(function (t) {
      var p = t.split(':'); return { n: parseInt(p[0], 10) || 0, pct: parseInt(p[1], 10) || 0 };
    }).filter(function (t) { return t.n > 0; }).sort(function (a, b) { return a.n - b.n; });
  }
  /* A store with no `bundles` collection renders data-excluded="null"; anything but an array is
     an empty list, never a TypeError on cart:change (review round two, 2026-09-25). */
  function parseList(s) { try { var v = JSON.parse(s || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function parseObj(s) { try { var o = JSON.parse(s || '{}'); return (o && typeof o === 'object') ? o : {}; } catch (e) { return {}; } }
  /* THE CHECKOUT'S RULE (N-44, 2026-09-25): a line-for-line port of buildPools/lineFacts in the
     discount Function (nesw-bundles extensions/bundle-discount/src/tiers.js, itself ported from the
     Ignis Function), cart mode only. Returns the pool AND how many lines would RECEIVE the tier: a
     cart of packs alone reaches the count but nothing is discounted, so the bar must not say
     "unlocked" then.
       - a product whose override is enabled:false counts nothing (a merchant's "off" wins);
       - a line is a server-known bundle when its variant has a valid pack count (a whole number
         1..50) or its product is a listed bundle/pack product, and it is not an expanded
         component: it counts its items when bundles count, receives only when bundles receive;
       - a line marked a pack ONLY by a cart property (_ignis_pack / _ignis_pack_id) counts what a
         plain line of its product counts and never receives;
       - every other participating unit counts 1 and receives. */
  function itemCount(v) { return (typeof v === 'number' && v % 1 === 0 && v >= 1 && v <= 50) ? v : null; }
  function poolIgnis(cart, el) {
    var mode = el.getAttribute('data-ig-mode') || 'all', list = parseList(el.getAttribute('data-ig-list'));
    var bundleProducts = parseList(el.getAttribute('data-ig-bundles')).concat(parseList(el.getAttribute('data-ig-packs')));
    var bcounts = parseObj(el.getAttribute('data-ig-bundle-counts')), pcounts = parseObj(el.getAttribute('data-ig-pack-counts'));
    var overrides = parseObj(el.getAttribute('data-ig-overrides'));
    var countBundles = el.getAttribute('data-ig-count-bundles') === '1', bundlesReceive = el.getAttribute('data-ig-bundles-receive') === '1';
    /* Pairings (review r7): the Function takes an INTACT pair's units out of the tiers before counting.
       With pairings on, a line stamped _bundle_id is left out here: a broken pair is under-counted (the
       bar and quotes promise less than checkout gives), never over-counted. Off: nothing changes. */
    var pairingsOn = el.getAttribute('data-ig-pairings') === '1';
    function off(pid) { var o = overrides[pid]; return !!(o && o.enabled === false); }
    function participates(pid) { if (off(pid)) return false; var inList = list.indexOf(pid) >= 0; return mode === 'include' ? inList : mode === 'exclude' ? !inList : true; }
    var pool = 0, receivers = 0;
    (cart && cart.items || []).forEach(function (it) {
      var units = parseInt(it.quantity, 10) || 0; if (units <= 0) return;
      var pid = 'gid://shopify/Product/' + it.product_id, props = it.properties || {};
      if (pairingsOn && props._bundle_id != null && props._bundle_id !== '') return;
      var packComponent = props._ignis_pack_id != null && props._ignis_pack_id !== '', packLine = props._ignis_pack != null && props._ignis_pack !== '';
      var byVariant = itemCount(pcounts[String(it.variant_id || '')]);
      var serverKnown = byVariant != null || bundleProducts.indexOf(pid) >= 0;
      if (serverKnown && !packComponent) {
        if (off(pid)) return;
        var receives = bundlesReceive && participates(pid);
        if (!countBundles && !receives) return;
        var items = byVariant != null ? byVariant : (itemCount(bcounts[pid]) || 1);
        pool += units * (countBundles ? items : 1);
        if (receives) receivers++;
        return;
      }
      if (packComponent || packLine) { if (participates(pid)) pool += units; return; }
      if (!participates(pid)) return;
      pool += units; receivers++;
    });
    return { n: pool, receivers: receivers };
  }
  function count(cart, el) {
    if (el.getAttribute('data-ignis') === '1') return poolIgnis(cart, el).n;
    var elig = parseList(el.getAttribute('data-eligible')), excl = parseList(el.getAttribute('data-excluded'));
    var useElig = elig.length > 0, n = 0;
    (cart && cart.items || []).forEach(function (it) {
      var h = it.handle || it.product_handle || '';
      var ok = useElig ? elig.indexOf(h) >= 0 : excl.indexOf(h) < 0;
      if (ok) n += parseInt(it.quantity, 10) || 0;
    });
    return n;
  }
  window.__neswOfferCount = count;
  /* THE PRICE A SHOPPER WILL PAY (Jay 2026-09-25: "people can tell the prices they're actually getting
     before checkout"). neswTierQuote({productId, variantId, cents, qty, properties}) answers, from the
     cart as it is now plus this addition, what ONE unit of it will cost at checkout under the Ignis cart
     pool: the same rule as poolIgnis (so the same as the Function), the tier the new pool reaches, and
     the Function's whole-dollar rounding (the unit price lands DOWN on a whole dollar, never less than
     the percent; nesw-bundles cart_lines_discounts_generate_run.js wholeDollarOff). Returns null when
     nothing comes off: no Ignis cart mode on this page, the item never receives (a pack, a product
     switched off), or the pool stays under the first tier. Sale stacking is not modelled: NESW runs no
     sale_amounts, so the base is the variant price. Synchronous against the last cart seen; listen for
     `nesw:tiercart` (fired after every cart read) and re-ask. */
  function igEl() { return document.querySelector('[data-nesw-offer-bar][data-ignis="1"]'); }
  function wholeDollarUnit(base, pct) {
    var off = Math.round(base * pct / 100);
    if (!(off > 0)) return base;
    if (base < 100) return base - off;
    return Math.floor(Math.max(0, base - off) / 100) * 100;
  }
  window.neswTierQuote = function (line) {
    var el = igEl(); if (!el || !lastCart || !line) return null;
    var cents = parseInt(line.cents, 10) || 0, qty = parseInt(line.qty, 10) || 1; if (cents <= 0) return null;
    var item = { product_id: String(line.productId || '').replace(/\D/g, ''), variant_id: String(line.variantId || '').replace(/\D/g, ''), quantity: qty, properties: line.properties || {} };
    var before = poolIgnis(lastCart, el), alone = poolIgnis({ items: [item] }, el);
    if (!alone.receivers) return null;
    var pool = before.n + alone.n, tiers = parseTiers(el.getAttribute('data-tiers')), hit = null;
    tiers.forEach(function (t) { if (pool >= t.n && t.pct > 0) hit = t; });
    if (!hit) return null;
    var unit = wholeDollarUnit(cents, hit.pct);
    return unit < cents ? { pct: hit.pct, tierN: hit.n, cents: unit, was: cents } : null;
  };
  /* Card prices (2026-09-25): any element carrying data-quote-pid / data-quote-vid / data-quote-cents
     (and optionally data-quote-compare, cents) shows <del>full</del> quoted when the cart qualifies,
     and its own markup otherwise. The element's markup is its base; a writer that rewrites it (a pack
     chip reprice, a pack swap) must update the data-quote-* attributes and call neswPaintQuote(el);
     a rewrite is detected because the markup no longer equals what this painter last wrote. */
  window.neswPaintQuote = function (el) {
    if (!el || !el.getAttribute) return;
    if (el.__neswPainted == null || el.innerHTML !== el.__neswPainted) el.__neswBase = el.innerHTML;
    var pid = el.getAttribute('data-quote-pid'), q = null;
    if (pid) q = window.neswTierQuote({ productId: pid, variantId: el.getAttribute('data-quote-vid'), cents: el.getAttribute('data-quote-cents'), qty: 1 });
    var html = el.__neswBase;
    if (q) {
      var was = Math.max(parseInt(el.getAttribute('data-quote-compare'), 10) || 0, q.was);
      html = '<del>' + window.neswMoney(was) + '</del> ' + window.neswMoney(q.cents);
    }
    if (el.innerHTML !== html) el.innerHTML = html;
    el.__neswPainted = el.innerHTML;
    el.classList.toggle('is-tier-priced', !!q);
  };
  function paintQuotes(root) { [].forEach.call((root || document).querySelectorAll('[data-quote-pid]'), window.neswPaintQuote); }
  /* True once a quote can be trusted as the whole answer (Ignis cart mode on this page and the cart read):
     then a null quote means "no discount", and a surface's own ladder maths must not second-guess it. */
  window.neswTierReady = function () { return !!(igEl() && lastCart); };
  window.neswMoney = function (c) { var d = (c || 0) / 100; return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)); };
  window.__neswOfferPool = poolIgnis; /* pinned to the Function by tools/offer-bar-parity.mjs */
  window.__neswOfferBarLastCartForTest = function (c) { lastCart = c; }; /* the parity test's cart seam */
  function fmt(t, v) {
    return String(t).replace(/\{count\}/g, v.count + (v.count === 1 ? ' item' : ' items'))
      .replace(/\{left\}/g, v.left).replace(/\{n\}/g, v.n).replace(/\{pct\}/g, v.pct)
      .replace(/\{next_n\}/g, v.next_n).replace(/\{next_pct\}/g, v.next_pct);
  }
  function paint(el, cart) {
    var tiers = parseTiers(el.getAttribute('data-tiers'));
    if (!tiers.length) return;
    var max = tiers[tiers.length - 1], n = count(cart, el);
    var hit = null, next = null;
    tiers.forEach(function (t) { if (n >= t.n) hit = t; else if (!next) next = t; });
    /* Equal segments, one per tier: segment i fills from the previous tier's
       count to this tier's count, so 1 item is halfway along the first run. */
    var segs = el.querySelectorAll('[data-ob-segfill]'), prev = 0;
    tiers.forEach(function (t, i) {
      var frac = Math.max(0, Math.min(1, (n - prev) / (t.n - prev)));
      if (segs[i]) { segs[i].style.width = Math.round(frac * 100) + '%'; if (segs[i].parentNode) segs[i].parentNode.classList.toggle('is-hit', frac >= 1); }
      prev = t.n;
    });
    [].forEach.call(el.querySelectorAll('[data-ob-mark]'), function (m) { m.classList.toggle('is-hit', n >= (parseInt(m.getAttribute('data-ob-mark'), 10) || 0)); });
    var state, text;
    if (n <= 0) { state = 'start'; text = el.getAttribute('data-copy-start'); }
    else if (hit && el.getAttribute('data-ignis') === '1' && poolIgnis(cart, el).receivers === 0) {
      /* Enough items, but only packs: checkout discounts nothing until one more item joins, and
         that item takes the tier the pool reaches with it. */
      var withOne = null; tiers.forEach(function (t) { if (n + 1 >= t.n) withOne = t; });
      state = 'progress'; text = fmt(el.getAttribute('data-copy-progress'), { count: n, left: 1, n: withOne.n, pct: withOne.pct, next_n: withOne.n, next_pct: withOne.pct });
    }
    else if (!hit) { state = 'progress'; text = fmt(el.getAttribute('data-copy-progress'), { count: n, left: next.n - n, n: next.n, pct: next.pct, next_n: next.n, next_pct: next.pct }); }
    else if (next) { state = 'between'; text = fmt(el.getAttribute('data-copy-between'), { count: n, left: next.n - n, n: hit.n, pct: hit.pct, next_n: next.n, next_pct: next.pct }); }
    else { state = 'done'; text = fmt(el.getAttribute('data-copy-done'), { count: n, left: 0, n: hit.n, pct: hit.pct, next_n: hit.n, next_pct: hit.pct }); }
    el.setAttribute('data-state', state);
    var st = el.querySelector('[data-ob-status]'); if (st && text) st.textContent = text;
    var cn = el.querySelector('[data-ob-cart-count]');
    if (cn) { var total = parseInt(cart && cart.item_count, 10) || 0; cn.textContent = total; cn.hidden = total <= 0; }
  }
  var lastCart = null;
  function paintAll(cart) {
    lastCart = cart; [].forEach.call(document.querySelectorAll('[data-nesw-offer-bar]'), function (el) { paint(el, cart); });
    paintQuotes();
    window.__neswTierCart = cart; /* read by a ladder that starts after this event (nesw-bundles-v2.js) */
    try { document.dispatchEvent(new CustomEvent('nesw:tiercart', { detail: { cart: cart } })); } catch (e) {}
  }
  function refetch() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && Array.isArray(c.items)) paintAll(c); })
      .catch(function () {});
  }
  document.addEventListener('cart:change', function (e) { var c = e.detail && (e.detail.cart || e.detail); if (c && Array.isArray(c.items)) paintAll(c); else refetch(); });
  document.addEventListener('cart:refresh', function (e) { var c = e.detail && (e.detail.cart || e.detail); if (c && Array.isArray(c.items)) paintAll(c); else refetch(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refetch(); });
  /* The drawer re-renders its own markup on every change; paint any bar that
     arrives later from the last cart we saw. */
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      var fresh = false;
      muts.forEach(function (m) { [].forEach.call(m.addedNodes, function (nd) {
        if (nd.nodeType !== 1) return;
        if (nd.matches('[data-nesw-offer-bar]') || nd.querySelector('[data-nesw-offer-bar]')) fresh = true;
        /* Cards appended later (infinite scroll, drawer re-render) get their quote too. */
        if (lastCart) { if (nd.matches('[data-quote-pid]')) window.neswPaintQuote(nd); else if (nd.querySelector('[data-quote-pid]')) paintQuotes(nd); }
      }); });
      if (fresh && lastCart) paintAll(lastCart);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  /* The card's cart button opens the theme's drawer the way the header button does. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-ob-cart]');
    if (!b) return;
    e.preventDefault();
    if (typeof window.openCartDrawer === 'function') { window.openCartDrawer(); return; }
    var hb = document.querySelector('[data-nesw-top-cart]');
    if (hb) hb.click(); else location.href = '/cart';
  });
  /* The server paints the first state; fetch at load only for a bar it did not. */
  if ([].some.call(document.querySelectorAll('[data-nesw-offer-bar]'), function (el) { return !el.getAttribute('data-ssr'); })) refetch();
  /* In Ignis cart mode the price quotes need the cart even when the server painted every bar. */
  else if (igEl()) { if (window.requestIdleCallback) requestIdleCallback(refetch, { timeout: 1500 }); else setTimeout(refetch, 600); }
})();
